import { MobileSelectionListItem } from "common/components/MobileSelectionList";
import MobileSelectionList from "common/components/MobileSelectionList/MobileSelectionList";
import ProfileHeading from "common/components/ProfileHeading";
import type { Lead } from "common/types";

import { LEADS_COLUMNS } from "../../constants";
import FavoriteLead from "../FavoriteLead";
import LeadNotesIndicator from "../LeadNotesIndicator";

import type { ReactNode } from "react";

type LeadsMobileListProps = {
  leads: Lead[];
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
  emptyStateComponent?: ReactNode;
} & ( // selection is only enabled when both the selection and its setter are passed
  | {
      selectedLeads: Lead[];
      setSelectedLeads: (selectedLeads: Lead[]) => void;
    }
  | { selectedLeads?: never; setSelectedLeads?: never }
);

export default function LeadsMobileList({
  leads,
  pageSize,
  isLoading,
  totalItemCount,
  emptyStateComponent,
  selectedLeads = [],
  setSelectedLeads,
}: LeadsMobileListProps) {
  if (leads && !leads.length) {
    return emptyStateComponent;
  }

  return (
    <MobileSelectionList
      title="Leads"
      data={leads || new Array(pageSize).fill({})}
      selection={selectedLeads}
      onSelectionChange={
        isLoading || !setSelectedLeads
          ? undefined
          : (newSelection) => {
              if (newSelection === "all") {
                setSelectedLeads(selectedLeads === leads ? [] : leads);
              } else {
                setSelectedLeads(newSelection);
              }
            }
      }
      totalDataCount={totalItemCount}
      allItems={LEADS_COLUMNS}
      canSelectAll={false}
    >
      {(lead, listItemProps) => {
        if (lead) {
          const { id, picture_url, notes, favorite, full_name, occupation } =
            lead;

          return (
            <MobileSelectionListItem
              {...listItemProps}
              relativeTo={`/leads/${id}`}
            >
              {isLoading ? (
                <ProfileHeading isLoading />
              ) : (
                <ProfileHeading
                  fullName={full_name}
                  pictureUrl={picture_url}
                  occupation={occupation}
                  extraComponent={
                    <div className="flex gap-x-1 items-center">
                      <LeadNotesIndicator noteCount={notes.length} />
                      <FavoriteLead leadId={id} isFavorite={favorite} />
                    </div>
                  }
                />
              )}
            </MobileSelectionListItem>
          );
        }
      }}
    </MobileSelectionList>
  );
}
